import Glossary from "./Glossary";
import UnderstandDatas from "./UnderstandDatas";

const MethodologyComponents = {
  UnderstandDatas,
  Glossary,
};

export default MethodologyComponents;
